// Answers offered by the exchange forms, shared with the demo generator.
// Each CVC and Hestia list is ordered by score: the answer at index n starts
// with "n:", which is what extractScore reads.

export const STAT_FORM_OPTIONS = {
    // The last entry ends with a non-breaking space (U+00A0) to match the values already stored.
    // Callers must use this constant rather than retype the label.
    formatEchanges: ["Accompagnement", "Contact téléphonique", "En rue", "Visite en logement", "Au CDJ DoucheFLUX", "Permanence", "En institution "],
    contenuEchanges: ["Logement", "Psycho", "Médical", "Social", "Soutien"],
    presences: ["Présent.e", "Absent.e", "Non applicable à cet échange", "Rendez-vous annulé"],
    entreeDansAppartement: ["Oui", "Non"],
    distributionKitRDR: ["Non", "Oui, kit d'injection", "Oui, kit d'inhalation", "Oui, paquet d'alu"],
}

export const CVC_OPTIONS = {
    corps: [
        "0: Saleté apparente avec parasites ou saleté apparente avec odeurs",
        "1: Saleté apparente ou parasites ou odeurs ou plaie non soignée",
        "2: Négligence",
        "3: Propre et soigné",
    ],
    vetements: [
        "0: Sales, abîmés et malodorants",
        "1: Sales et malodorants ou sales et abîmés ou inadaptés",
        "2: Sales ou abîmés ou malodorants",
        "3: Cohérents, propres et en bon état",
    ],
    comportement: [
        "0: Anormal et dangereux",
        "1: Anormal ou dangereux",
        "2: Suscite un questionnement",
        "3: Normal",
    ],
}

export const HESTIA_OPTIONS = {
    voisinage: [
        "0: Conflits de voisinage non gérés",
        "1: Conflits de voisinage gérés",
        "2: Absence de conflits de voisinage mais peu ou pas de contacts",
        "3: Bonne entente avec le voisinage",
    ],
    hygiene: [
        "0: Si cumule au moins 2 items: odeurs nauséabondes, nuisibles, altération du matériel, accumulation",
        "1: Odeurs nauséabondes ou nuisibles ou altération du matériel ou accumulation",
        "2: Logement relativement propre et entretenu mais pas impeccable ou aides familiales limitées",
        "3: Logement impeccable et/ou aides familiales régulières et fonctionnelles",
    ],
    bailleur: [
        "0: Absence de paiement du loyer",
        "1: Loyer payé sans garantie de régularité ou de manière erronée",
        "2: Existence d'un garant du paiement mais pas de la signature des baux",
        "3: Garantie du paiement du loyer et de la signature des baux",
    ],
}

export const HESTIA2_OPTIONS = {
    securite: [
        "0: Logement insalubre et mal utilisé",
        "1: Logement insalubre ou mal utilisé",
        "2: Logement bien utilisé mais que partiellement sain et fonctionnel",
        "3: Logement parfaitement utilisé, totalement sain et fonctionnel",
    ],
    sante: [
        "0: Refus des soins, non prise du traitement et aucun contact extérieur",
        "1: Refus des soins, non prise du traitement mais contacts acceptés",
        "2: Certains soins acceptés, prise du traitement de manière irrégulière, contacts acceptés",
        "3: Autonomie dans la prise du traitement, bon lien avec médecin traitant et/ou infirmière à domicile",
    ],
    consommation: [
        "0: Une ou plusieurs dépendances non conscientisées, consommation massive et mise en danger",
        "1: Une ou plusieurs dépendances conscientisées, changement non envisagé",
        "2: Une ou plusieurs dépendances gérées, avec diminution de la mise en danger, ou non gérées mais avec changement envisagé",
        "3: Absence de consommation(s) - abstinence",
    ],
}
